module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoBlkOlIt.9172c284.otf";